




















import { RouteConfig } from 'vue-router';
import { Component, Vue } from 'vue-property-decorator';
import {
  Chat,
  Memos,
  Characters,
  Map,
} from '@/browser/routes';

@Component
export default class RoomBottomNav extends Vue {
  get chat(): RouteConfig {
    return Chat;
  }

  get memos(): RouteConfig {
    return Memos;
  }

  get characters(): RouteConfig {
    return Characters;
  }

  get map(): RouteConfig {
    return Map;
  }
}
